import React from 'react'
import { SnackbarKey, useSnackbar } from 'notistack'
import { removeSnackbar } from '../store/actions'
import { useDispatch, useSelector } from '../store'
import { Button } from '@mui/material'
import { IconX } from '@tabler/icons'

let displayed: SnackbarKey[] = []

const useNotifier = () => {
  const dispatch = useDispatch()
  const notifier = useSelector(state => state.notifier)
  const { notifications } = notifier

  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const storeDisplayed = id => {
    displayed = [...displayed, id]
  }

  const removeDisplayed = id => {
    displayed = [...displayed.filter(key => id !== key)]
  }

  React.useEffect(() => {
    notifications.forEach(({ key, message, options = {}, dismissed = false }) => {
      if (dismissed) {
        // dismiss snackbar using notistack
        closeSnackbar(key)
        return
      }

      // do nothing if snackbar is already displayed
      if (displayed.includes(key)) return

      const { dismissible, ...snackbarOptions } = options

      // display snackbar using notistack
      enqueueSnackbar(message, {
        key,
        ...snackbarOptions,
        ...(dismissible && {
          action: (snackbarKey: SnackbarKey) =>
            React.createElement(
              Button,
              { style: { color: 'white' }, onClick: () => closeSnackbar(snackbarKey) },
              React.createElement(IconX)
            ),
        }),
        onExited: (event, myKey) => {
          // remove this snackbar from redux store
          dispatch(removeSnackbar(myKey))
          removeDisplayed(myKey)
        },
      })

      // keep track of snackbars that we've displayed
      storeDisplayed(key)
    })
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch])
}

export default useNotifier
